import { render, staticRenderFns } from "./FormPickupDropOff.vue?vue&type=template&id=570e419d&scoped=true&"
import script from "./FormPickupDropOff.vue?vue&type=script&lang=js&"
export * from "./FormPickupDropOff.vue?vue&type=script&lang=js&"
import style0 from "./FormPickupDropOff.vue?vue&type=style&index=0&id=570e419d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e419d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VIcon,VRow,VSpacer})
